

export class ToolTipOptionAddInput implements IToolTipOptionAddInput {
    /** The auto-generated id of the tool tip header master master */
    tooltipHeaderId!: number;
    /** The tool tip option name  with 255 character limit */
    tooltipOptionName!: string;

    constructor(data?: IToolTipOptionAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tooltipHeaderId = _data["tooltipHeaderId"];
            this.tooltipOptionName = _data["tooltipOptionName"];
        }
    }

    static fromJS(data: any): ToolTipOptionAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new ToolTipOptionAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tooltipHeaderId"] = this.tooltipHeaderId;
        data["tooltipOptionName"] = this.tooltipOptionName;
        return data; 
    }
}

export interface IToolTipOptionAddInput {
    /** The auto-generated id of the tool tip header master master */
    tooltipHeaderId: number;
    /** The tool tip option name  with 255 character limit */
    tooltipOptionName: string;
}

